import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subscriber } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ProductService {

  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  searchProducts(searchString) {
    return this.http.get(
      this.baseUrl + `products/search?searchString=${searchString}`
    );
  }

  searchVendorProducts(searchString) {
    return this.http.get(
      this.baseUrl + `products/vendorSearch?searchString=${searchString}`
    );
  }

  searchVendorProductsNew(searchProductName, searchProductCode, searchMfgName) {
    return this.http.get(
      this.baseUrl +
// tslint:disable-next-line: max-line-length
        `products/vendorSearchNew?searchProductName=${searchProductName}&searchProductCode=${searchProductCode}&searchMfgName=${searchMfgName}`
    );
  }

  getAllProductsByAuthority(searchString) {
    return this.http.get(
      this.baseUrl + `products/GetAllInventoryProducts?searchString=${searchString}`
    );
  }

  createProduct(product: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.post(this.baseUrl + 'Inventory/CreateProduct', product,
    {headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response'});
  }

  testFunction(model: any) {
    return this.http.post(this.baseUrl + `products/Upload`, model);
  }

  updateProduct(id: any, model: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.put(this.baseUrl + `Inventory/UpdateProduct/` + id, model,
    { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  removeProduct(id: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.delete(this.baseUrl + `Inventory/` + id, {
      headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response'});
  }

  removeProductLocation(productId: number, rootAuthorityUnitId: number, productAuthorityId: number) {
    return this.http.post(this.baseUrl + 'products/RemoveProductFromLocation', { productId, rootAuthorityUnitId, productAuthorityId });
  }

  productCasNumberFilter() {
    return this.http.get(this.baseUrl + 'products/productCasNumbers');
  }

  // getPDF(productId: number): Observable<any> {
  //   return this.http.get(this.baseUrl + 'products/GetSDSPDF/' + productId, {
  //     responseType: 'blob' as 'json', observe: 'response'
  //   });
  // }

  getPDF(productId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'FileUpload/DownloadFile/' + productId, {
      responseType: 'blob' as 'json', observe: 'response'
    });
  }

  getCloudSDS(searchString): Observable<any> {
    return this.http.get(this.baseUrl + `products/sdsdoc?searchString=${searchString}`, {
      responseType: 'blob' as 'json', observe: 'response'
    });
  }

  createMultipleArchives(): Observable<any> {
    return this.http.get(this.baseUrl + 'products/createMultipleBackup', {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'blob'
    });
  }

  createArchive(model: any): Observable<any> {
   // console.log(productId);
   let tokenString = '';
   const securityToken: string = localStorage.getItem('token');
   let httpHeaders = new HttpHeaders();
   if (securityToken != null) {
     tokenString = `Bearer ${securityToken}`;
     httpHeaders = new HttpHeaders()
       .set('authorization', tokenString)
       .set('Content-Type', 'application/json');
   } else {
     httpHeaders = new HttpHeaders()
       .set('Content-Type', 'application/json');
   }
    return this.http.post(this.baseUrl + `Inventory/CreateBackUp`, model, 
    {headers: httpHeaders, responseType: 'blob', observe: 'response'});
  }
  
  getProductbyId(id: number) {
    return this.http.get(this.baseUrl + 'products/' + id);
  }

  getProductDetails(id: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.get(this.baseUrl + 'Inventory/ProductDetail/' + id, {headers: httpHeaders});
  }

  getAdminProductDetails(id: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.get(this.baseUrl + 'Inventory/AdminProductDetail/' + id, {headers: httpHeaders});
  }

  getRelatedProductsById(id: number) {
    return this.http.get(this.baseUrl + 'products/getrelatedProducts/' + id);
  }

  searchSDSProducts(searchString) {
    return this.http.get(
      this.baseUrl + `products/searchSDS?searchString=${searchString}`
    );
  }

  uploadSDSFile(model:any) {
    return this.http.post(this.baseUrl + `products/UploadSDSFile?${model}`, model, { reportProgress: true, observe: 'events'});
  }

  findProducts(model: any) {
    let httpHeaders = new HttpHeaders();
    httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.baseUrl + `search/FindProducts`, model, {headers: httpHeaders, observe: 'response'});
  }

  findInventoryProducts(model: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.post(this.baseUrl + `Inventory/GetAllInventoryProducts`, model, {headers: httpHeaders, observe: 'response'});
  }

  createSecondaryName(id: number, model: any) {
    return this.http.post(this.baseUrl + `products/createSecondaryName/` + id, model);
  }

  updateSecondaryName(id: number, model: any) {
    return this.http.put(this.baseUrl + 'products/UpdateSecondaryName/' + id, model);
  }

  productLocation() {
    return this.http.get(this.baseUrl + 'products/ProductLocationDropDown');
  }

  getinventoryProductDetail(model: any) {
    return this.http.post(this.baseUrl + `products/InventoryProductDetail?${model}`, model, {observe: 'response'});
  }

  getSearchProductDetail(model: any) {
    return this.http.post(this.baseUrl + `search/SearchProductDetail?${model}`, model, {observe: 'response'});
  }

  // getCloudSDSSearchProductDetail(msds_id: number) {
  //   return this.http.get(this.baseUrl + 'products/SearchCloudSDSDetail/' + msds_id);
  // }

  getVendorAPIInventoryProductDetail(msdsId: string) {
    return this.http.get(this.baseUrl + 'products/GetVendorAPIInventoryDetail/' + msdsId);
  }

  assignProductLocation(l: any, model: any) {
    console.log(model);
    return this.http.post(this.baseUrl + `products/AssignProductToLocation?${l}`,  model, {observe: 'response'});
  }
}